import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class Config implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(private fId: string, private fIsEnabled: boolean) {
    [fId, fIsEnabled].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get isEnabled(): boolean {
    return this.fIsEnabled;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
